<template>
     <div class="go-top">
      <i class="fas fa-arrow-up"></i>
    </div>
</template>

<script>
export default {
    
}
</script>